export default "__VITE_PUBLIC_ASSET__78a5cb46__"